import React, { useEffect, useState } from "react";
import { Box, Checkbox, Grid, TextField, FormControlLabel, Typography } from "@mui/material";
import { useFormikContext } from "formik";
import { getCities, getCountries, getStates } from "../../config/countries";
import AutoComplete from "../AutoComplete";
import format from '../../constants/format';

const AddressMenu = () => {
    const formik = useFormikContext();
    const [loading, setloading] = useState({ value: false, prop: "" });
    const [data, setData] = useState({ countries: [], states: [], cities: [] });
    const [checked, setChecked] = useState({
        country: true,
        state: true,
        city: true,
    });

    const fetchData = (prop, country, state) => {
        const getData =
            prop === "countries"
                ? getCountries()
                : prop === "states"
                    ? getStates(country)
                    : getCities(country, state);
        setloading({ value: true, prop: prop });
        getData
            .then((x) => {
                setData({ ...data, [prop]: x.data });
            })
            .finally(() => setloading({ ...loading, value: false }));
    };

    useEffect(() => {
        fetchData("countries");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChangeCheckBox = (prop) => (event) => {
        formik.setFieldValue(prop, null);
        switch (prop) {
            case 'country':
                setChecked({
                    ...checked,
                    [prop]: event.target.checked,
                    state: !checked['state'],
                    city: !checked['city']
                });
                break;
            case 'state':
                setChecked({ ...checked, [prop]: event.target.checked, city: !checked['city'] });
                break;
            default:
                setChecked({ ...checked, [prop]: event.target.checked });
                break;
        }
    };

    const getDisable = (prop) => {
        switch (prop) {
            case "state":
                return !checked["country"];
            case "city":
                return !(checked["country"] && checked["state"]);
            default:
                return false;
        }
    };

    return (
        <Box id="Location-menu-id">
            <Grid container spacing={3}>
                {[
                    { prop: "country", list: "countries", label: "Country" },
                    { prop: "state", list: "states", label: "State/Province" },
                    { prop: "city", list: "cities", label: "City" },
                ].map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                            <Box sx={{ flex: 1 }}>
                                {checked[item.prop] ? (
                                    <AutoComplete
                                        prop={item.prop}
                                        options={data[item.list]}
                                        fetchData={fetchData}
                                        loading={loading.prop === item.list && loading.value}
                                    />
                                ) : (
                                    <TextField
                                        id={item.prop}
                                        label={item.label}
                                        onChange={formik.handleChange(item.prop)}
                                        variant="outlined"
                                        fullWidth
                                        required
                                    />
                                )}
                            </Box>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        color="primary"
                                        checked={checked[item.prop]}
                                        disabled={getDisable(item.prop)}
                                        onChange={handleChangeCheckBox(item.prop)}
                                        size="small"
                                    />
                                }
                                label={<Typography variant="caption">List</Typography>}
                                sx={{ mt: 1 }}
                            />
                        </Box>
                    </Grid>
                ))}

                <Grid item xs={12} sm={8}>
                    <TextField
                        id="street"
                        label="Street Address"
                        onChange={formik.handleChange("street")}
                        variant="outlined"
                        fullWidth
                        disabled={true}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextField
                        id="zipcode"
                        label="Postal/Zip Code"
                        type="number"
                        onChange={formik.handleChange("zipcode")}
                        variant="outlined"
                        fullWidth
                        disabled={true}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default AddressMenu;
